import api, { API_BASE_URL } from './api';

/**
 * Build a browser-loadable document URL (PDF viewer, window.open, <img>) carrying a
 * short-lived (~60 s) token scoped to ONE kb+document, minted by the backend.
 *
 * Never put the session JWT in a URL: URLs land in proxy/access logs and browser history.
 * The scoped token is issued by POST .../view-token (header-authenticated + RBAC checked
 * there), so a leaked URL is useless after a minute and never grants anything else.
 * Mint at the moment of use - a token minted earlier may already be expired.
 */
export async function mintDocumentViewUrl(
  kbId: string,
  documentId: string,
  path: string = 'pdf',
  extraQuery: string = '',
): Promise<string> {
  const { data } = await api.post<{ token: string }>(
    `/knowledge-bases/${kbId}/documents/${documentId}/view-token`,
  );
  const sep = path.includes('?') ? '&' : '?';
  const extra = extraQuery ? `&${extraQuery}` : '';
  return `${API_BASE_URL}/knowledge-bases/${kbId}/documents/${documentId}/${path}${sep}token=${data.token}${extra}`;
}
